import React, { Component } from "react";
import { gantt } from "dhtmlx-gantt";
import "dhtmlx-gantt/codebase/dhtmlxgantt.css";
import "dhtmlx-gantt/codebase/ext/dhtmlxgantt_marker.js";

export default class Gantt extends Component {
  // instance of gantt.dataProcessor
  dataProcessor = null;

  /**
   * applies one of the predefined settings of the time scale
   */

  setZoom(value) {
    switch (value) {
      case "Days":
        gantt.config.min_column_width = 70;
        gantt.config.scale_unit = "week";
        gantt.config.date_scale = "Week No. %W";
        gantt.config.subscales = [{ unit: "day", step: 1, date: "%d %M" }];
        gantt.config.scale_height = 60;
        break;
      case "Months":
        gantt.config.min_column_width = 70;
        gantt.config.scale_unit = "month";
        gantt.config.date_scale = "%F";
        gantt.config.scale_height = 60;
        gantt.config.subscales = [{ unit: "week", step: 1, date: "%d %M" }];
        break;
      default:
        break;
    }
  }

  initGanttDataProcessor() {
    const onDataUpdated = this.props.onDataUpdated;
    this.dataProcessor = gantt.createDataProcessor((type, action, item, id) => {
      return new Promise((resolve, reject) => {
        if (onDataUpdated) {
          onDataUpdated(type, action, item, id);
        }

        // if onDataUpdated changes returns a permanent id of the created item, you can return it from here so dhtmlxGantt could apply it
        // resolve({id: databaseId});
        return resolve();
      });
    });
  }

  shouldComponentUpdate(nextProps) {
    return this.props.zoom !== nextProps.zoom;
  }

  componentDidUpdate() {
    gantt.render();
  }

  componentDidMount() {
    const { tasks } = this.props;

    gantt.config.xml_date = "%Y-%m-%d %H:%i";
    gantt.config.readonly = true;
    gantt.config.select_task = false;
    gantt.config.row_height = 60;
    gantt.config.scale_height = 45;
    // gantt.config.grid_width = 550;
    gantt.config.date_grid = "%d/%m/%Y";
    gantt.config.initial_scroll = false;

    gantt.config.columns = [
      {
        name: "text",
        label: "Task name",
        tree: true,
        min_width: 170,
        align: "left"
      },
      {
        name: "start_date",
        label: "Start date",
        align: "center",
        min_width: 120,
        width: 150
      },
      {
        name: "end_date",
        label: "End date",
        align: "center",
        min_width: 120,
        width: 150
      },
      {
        name: "progress",
        label: "% Completed",
        align: "center",
        min_width: 80,
        max_width: 100,
        width: 90,
        template: function(obj) {
          return obj.progress * 100;
        }
      }
    ];

    gantt.templates.task_text = function(start, end, task) {
      return task.text;
    };

    gantt.templates.grid_file = function(item) {
      return "";
    };

    gantt.templates.leftside_text = function(start, end, task) {
      return task.duration + " days";
    };

    gantt.templates.rightside_text = function(start, end, task) {
      return task.progress * 100 + "%";
    };

    gantt.init(this.ganttContainer);
    this.initGanttDataProcessor();
    gantt.parse(tasks);
    gantt.showDate(new Date());
  }

  componentWillUnmount() {
    const { tasks } = this.props;

    tasks.data.forEach(task => {
      gantt.deleteTask(task.id);
    });

    if (this.dataProcessor) {
      this.dataProcessor.destructor();
      this.dataProcessor = null;
    }
  }

  render() {
    const { zoom } = this.props;
    var date_to_str = gantt.date.date_to_str(gantt.config.task_date);

    this.setZoom(zoom);

    var id = gantt.addMarker({
      start_date: new Date(),
      css: "today",
      text: "Today",
      title: date_to_str(new Date())
    });

    setInterval(function() {
      var today = gantt.getMarker(id);
      today.start_date = new Date();
      today.title = date_to_str(today.start_date);
      gantt.updateMarker(id);
    }, 1000 * 60);

    return (
      <div
        ref={input => {
          this.ganttContainer = input;
        }}
        style={{ width: "100%", height: "100%" }}
      ></div>
    );
  }
}
